import { render, staticRenderFns } from "./StoryFilePreview.vue?vue&type=template&id=65f78384&scoped=true"
import script from "./StoryFilePreview.vue?vue&type=script&lang=js"
export * from "./StoryFilePreview.vue?vue&type=script&lang=js"
import style0 from "./StoryFilePreview.vue?vue&type=style&index=0&id=65f78384&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f78384",
  null
  
)

export default component.exports